import React from "react";
import { getExperienceBarWidth } from "./blockHelpers";

const OverviewComponent = ({ program }) => {
  const notSingleWorkout = program.storeType !== "single-workout";

  return (
    <>
      {program.difficulty && (
        <div className="exp-wrapper">
          <p className="s1">Experience level</p>
          <div className="experience-level-container">
            <p className="s3">Beginner</p>
            <p className="s3">Expert</p>
          </div>
          <div className="bar">
            <div
              className="progress-filled"
              style={{ width: `${getExperienceBarWidth(program.difficulty)}%` }}
            ></div>
          </div>
        </div>
      )}

      {notSingleWorkout && (
        <div className="blocks-wrapper">
          {program.programs && program.programs.length > 0 ? (
            <>
              <p className="s1">Blocks</p>
              <ul>
                {program.programs.map((block) => (
                  <li key={`${block.order}-${block.name}`}>
                    <p className="p2">{block.name}</p>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p className="p2">No blocks found for this program</p>
          )}
        </div>
      )}
    </>
  );
};

export default OverviewComponent;
